import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

function StatCounter({ target, suffix = "", duration = 1200 }) {
  const [value, setValue] = useState(0);
  const elRef = useRef(null);
  const animatedRef = useRef(false);

  useEffect(() => {
    const el = elRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !animatedRef.current) {
            animatedRef.current = true;
            let start = null;
            function step(ts) {
              if (!start) start = ts;
              const progress = Math.min((ts - start) / duration, 1);
              const val = target * progress;
              setValue(
                target % 1 === 0 ? Math.floor(val) : Number(val.toFixed(1)),
              );
              if (progress < 1) requestAnimationFrame(step);
            }
            requestAnimationFrame(step);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.4 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [target, duration]);

  return (
    <strong ref={elRef}>
      {value}
      {suffix}
    </strong>
  );
}

export default function About() {
  window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <>
      <>
        <section className="section">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <span className="kicker">Why enroll with L2E</span>
                <h2 className="mt-2">
                  Clarity, confidence and an edge — whether you join online or
                  offline
                </h2>
                <p className="text-muted-soft">
                “At Learning to Earning (L2E), every benefit is carefully designed to move you closer to true trading mastery. From live market demonstrations to real-world case studies, we focus on practical, hands-on learning. It’s not just theory on slides — it’s real experience, real strategies, and real confidence to succeed in the markets.”
                </p>
                <a
                  href="https://wa.me/7004654910?text=Hi%2C%20I%20saw%20your%20website%2C%20I%27m%20interested%20in%20your%20courses.%20Could%20you%20share%20more%20details%3F"
                  className="btn btn-brass"
                  target="_blank"
                  rel="noopener"
                >
                  Start Learning Now
                </a>
              </div>
              <div className="col-lg-6 mt-4 mt-lg-0">
                <div className="row">
                  <div className="col-12 mb-3">
                    <img
                      src="assets/website/img/about-1.png"
                      className="img-fluid rounded"
                      alt="L2E students sitting"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="section bg-paper">
          <div className="container">
            <div className="row text-center">
              <div className="col-6 col-md-3">
                <div className="stat-block">
                  <StatCounter target={24} suffix="k+" />
                  <span>Students Enrolled</span>
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="stat-block">
                  <StatCounter target={2} suffix="k+" />
                  <span>Daily Live Classes</span>
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="stat-block">
                  <StatCounter target={3.5} suffix="M" />
                  <span>Video Lessons</span>
                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="stat-block">
                  <StatCounter target={75} suffix="+" />
                  <span>Exam Categories</span>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <section className="section">
          <div className="container">
            <div className="section-head mx-auto text-center">
              <span className="kicker justify-content-center">
                Success stories
              </span>
              <h2>What our students say</h2>
            </div>
            <div className="row">
              <div className="col-md-4 mb-4">
                <div className="testi-card">
                  <span className="quote-mark">"</span>
                  <p>
                    I honestly dislike writing reviews, but for this institute I
                    had to make an exception. Choosing them has been one of the
                    best decisions I've made.
                  </p>
                  <div className="testi-name">Rajveer Singh</div>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="testi-card">
                  <span className="quote-mark">"</span>
                  <p>
                    I believe in lifelong learning, and this is a great place to
                    learn from mentors who actually know the craft.
                  </p>
                  <div className="testi-name">Shweta Basu Prasad</div>
                  <div className="testi-role">Business</div>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="testi-card">
                  <span className="quote-mark">"</span>
                  <p>
                    What I learned here I couldn't find on YouTube, even in paid
                    courses. At L2E I finally got theory and practical learning
                    that made real sense.
                  </p>
                  <div className="testi-name">Rihan</div>
                  <div className="testi-role">Student</div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <section className="success-section">
          <div className="container">
            {/* left dotted teal pattern */}
            <div className="dot-pattern" />
            <div className="row">
              <div className="col-md-6">
                {/* testimonial card */}
                <div className="testimonial-card mt-5">
                  <h2 className="title">
                    Including large benefit when you enroll from our courses
                  </h2>
                  <p className="quote">
                    At L2E, learning is designed to give you clarity,
                    confidence, and an edge. Whether you join online or offline,
                    every benefit moves you closer to mastery.
                  </p>
                  <p className="quote">
                    See how concepts work in the real world through guided
                    .-market demonstrations and case studies.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                {/* right visual area */}
                <div className="visual-area">
                  <div className="dashed-ring" />
                  <div className="dot-grid" />
                  <div className="yellow-crescent" />
                  <div className="red-triangle" />
                  <div className="photo-circle">
                    <img
                      src="assets/website/img/learning-1.jpg"
                      alt="Students in classroom"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="section bg-paper">
          <div className="container">
            <div className="section-head mx-auto text-center">
              <span className="kicker justify-content-center">Leadership</span>
              <h2>Founder &amp; core leadership</h2>
            </div>
            <div className="row justify-content-center">
              <div className="col-6 col-md-3 mb-4">
                <div className="team-card">
                  <div className="team-photo">
                    <span>AR</span>
                  </div>
                  <div className="team-name">Amit Rawat</div>
                  <div className="team-role">
                    Founder &amp; Managing Director
                  </div>
                </div>
              </div>
              <div className="col-6 col-md-3 mb-4">
                <div className="team-card">
                  <div className="team-photo">
                    <span>MN</span>
                  </div>
                  <div className="team-name">Manmohan Negi</div>
                  <div className="team-role">CEO</div>
                </div>
              </div>
              <div className="col-6 col-md-3 mb-4">
                <div className="team-card">
                  <div className="team-photo">
                    <span>RM</span>
                  </div>
                  <div className="team-name">Rohit Mahajan</div>
                  <div className="team-role">Franchise / Regional Head</div>
                </div>
              </div>
            </div>
            <div className="section-head mx-auto text-center mt-5">
              <span className="kicker justify-content-center">Faculty</span>
              <h2>Mentors &amp; trainers</h2>
            </div>
            <div className="row justify-content-center">
              <div className="col-6 col-md-3 mb-4">
                <div className="team-card">
                  <div className="team-photo">
                    <span>RP</span>
                  </div>
                  <div className="team-name">Ramesh Pal</div>
                  <div className="team-role">Trainer, SEBI Registered</div>
                </div>
              </div>
              <div className="col-6 col-md-3 mb-4">
                <div className="team-card">
                  <div className="team-photo">
                    <span>DB</span>
                  </div>
                  <div className="team-name">Deepak Bisht</div>
                  <div className="team-role">Stock Market Trainer</div>
                </div>
              </div>
              <div className="col-6 col-md-3 mb-4">
                <div className="team-card">
                  <div className="team-photo">
                    <span>VG</span>
                  </div>
                  <div className="team-name">Vibhu Grewal</div>
                  <div className="team-role">Trainer</div>
                </div>
              </div>
              <div className="col-6 col-md-3 mb-4">
                <div className="team-card">
                  <div className="team-photo">
                    <span>HB</span>
                  </div>
                  <div className="team-name">Himanshu Bodh</div>
                  <div className="team-role">Trainer</div>
                </div>
              </div>
            </div>
            <div className="section-head mx-auto text-center mt-5">
              <span className="kicker justify-content-center">Support</span>
              <h2>Counsellors &amp; guidance team</h2>
            </div>
            <div className="row justify-content-center">
              <div className="col-6 col-md-3 mb-4">
                <div className="team-card">
                  <div className="team-photo">
                    <span>AM</span>
                  </div>
                  <div className="team-name">Anjali Mehra</div>
                  <div className="team-role">Head of Counsellors</div>
                </div>
              </div>
              <div className="col-6 col-md-3 mb-4">
                <div className="team-card">
                  <div className="team-photo">
                    <span>YT</span>
                  </div>
                  <div className="team-name">Yogita Tripathi</div>
                  <div className="team-role">Counsellor</div>
                </div>
              </div>
              <div className="col-6 col-md-3 mb-4">
                <div className="team-card">
                  <div className="team-photo">
                    <span>RK</span>
                  </div>
                  <div className="team-name">Rajiv Kandwal</div>
                  <div className="team-role">Sr. Counsellor</div>
                </div>
              </div>
              <div className="col-6 col-md-3 mb-4">
                <div className="team-card">
                  <div className="team-photo">
                    <span>R</span>
                  </div>
                  <div className="team-name">Rashmi</div>
                  <div className="team-role">Counsellor</div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center mt-3">
              <div className="col-6 col-md-3 mb-4">
                <div className="team-card">
                  <div className="team-photo">
                    <span>KK</span>
                  </div>
                  <div className="team-name">Kunal Kashyap</div>
                  <div className="team-role">
                    Digital Marketing &amp; Growth
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <section className="section">
          <div className="container">
            <div className="cta-band text-center">
              <h2>Want to meet the team before you enrol?</h2>
              <p className="mb-4">
                Visit our campus or book a free counselling call.
              </p>
              <Link to="/contact" className="btn btn-brass btn-lg btn-lg-879">
                Get in touch
              </Link>
            </div>
          </div>
        </section> */}
      </>
    </>
  );
}
